import { currencyFormatter } from "@common/helpers/currency";
import classNames from "classnames";
import { fromIntToMonetary, fromMonetaryToInt } from "@common/helpers/monetary";
import { CheckIcon, NotEqualIcon } from "@icons";
import styles from "./Reconciliation.module.scss";

interface Props {
    statementsTitle?: string;
    kickTitle: string;
    statementsValue?: number;
    kickValue: number | React.ReactNode;
    kickValueForCalculations?: number;
    firstStat?: boolean;
    lastStat?: boolean;
    alwaysExpanded?: boolean;
}

export const ReconciliationTableHeaderRow: React.FC<Props> = ({
    statementsTitle,
    kickTitle,
    statementsValue,
    kickValue,
    kickValueForCalculations: kickValueForCalculationsProp,
    firstStat,
    lastStat,
    alwaysExpanded,
}) => {
    const kickValueForCalculations =
        typeof kickValue === "number"
            ? kickValue
            : kickValueForCalculationsProp;
    if (typeof kickValueForCalculations !== "number") {
        throw new Error("Can't determine Kick value for calculations");
    }
    const hasDifference =
        statementsValue !== undefined &&
        statementsValue !== kickValueForCalculations;
    const difference =
        statementsValue !== undefined
            ? Math.abs(
                  fromIntToMonetary(
                      fromMonetaryToInt(statementsValue) -
                          fromMonetaryToInt(kickValueForCalculations),
                  ),
              )
            : undefined;

    return (
        <>
            <div
                className={classNames(styles.statsCell, {
                    [styles.firstStat]: firstStat,
                    [styles.lastStat]: lastStat,
                    [styles.alwaysExpanded]: alwaysExpanded,
                })}
            >
                {statementsTitle && (
                    <span className={styles.summaryStatTitle}>
                        {statementsTitle}
                    </span>
                )}
                {statementsValue !== undefined && (
                    <span
                        className={classNames(styles.summaryStatValue, {
                            [styles.hasDifference]: hasDifference,
                        })}
                    >
                        {currencyFormatter.format(statementsValue)}
                    </span>
                )}
            </div>

            <div
                className={classNames(styles.statsCell, {
                    [styles.firstStat]: firstStat,
                    [styles.lastStat]: lastStat,
                    [styles.alwaysExpanded]: alwaysExpanded,
                })}
            >
                <span className={styles.summaryStatTitle}>{kickTitle}</span>
                <span
                    className={classNames(styles.summaryStatValue, {
                        [styles.hasDifference]: hasDifference,
                    })}
                >
                    {typeof kickValue === "number"
                        ? currencyFormatter.format(kickValue)
                        : kickValue}
                </span>
            </div>

            <div
                className={classNames(
                    styles.statsCell,
                    styles.summaryDifferenceCell,
                    {
                        [styles.firstStat]: firstStat,
                        [styles.lastStat]: lastStat,
                        [styles.alwaysExpanded]: alwaysExpanded,
                    },
                )}
            >
                {difference !== undefined && (
                    <span
                        className={classNames(styles.summaryStatValue, {
                            [styles.hasDifference]: hasDifference,
                        })}
                    >
                        {currencyFormatter.format(difference)}
                    </span>
                )}
                {difference !== undefined &&
                    (hasDifference ? (
                        <NotEqualIcon className="icon-color-blue-600" />
                    ) : (
                        <CheckIcon />
                    ))}
            </div>
        </>
    );
};
